import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class FollowupEmailConfigProvider extends BaseApi {
	saveFollowupEmailConfig(dto: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/SaveFollowupEmailConfig`, dto);
	}
}
export const apiProvider = new FollowupEmailConfigProvider(DMS_MODULE, NAME);
